import { UserLanguage } from '../../../../features/account/types/User'

export const useLiveEventsTrackingUserLanguage = () => {
  return 'en' as UserLanguage
}
